import * as api from 'api/pgads'
import Task from 'data.task'
import {
  STORE_API_URL,
  // eslint-disable-next-line no-unused-vars
  STORE_TRANS_DATE,
  STORE_UNITS,
  STORE_ENV_CONFIG,
  STORE_COMPANY_NAME_MAP,
  // STORE_UTILITY_NAME_MAP,
  // CAUSE_CODE,
  EVENT_TYPES,
  STATIONS,
  // STORE_UNIT_CAUSE_CODE_MAP,
  // STORE_CAUSE_CODE_MAP,
  STORE_UNIT_TYPE_CODE,
} from './action-names'
import * as ANS from './action-names'
import * as sel from './selectors'
import R from 'ramda'
import { Just, Nothing } from 'data.maybe'
import { errorLogger, fromEmpty } from './utils'
import moment from 'moment'
import { List } from 'immutable-ext'
import { authApi } from '@integec/common-react-screens/lib/auth'
// import Cookies from 'js-cookie'
import { JWT_KEY, finalizeLogout, getMetaConfig } from '../utils'
import * as pgads from '../api/pgads'

import {
  getApiTargetInfo,
  getTransDate,
  getEnvConfig,
  isAuthenticated,
} from './selectors'

import { loadAnalyticsEnvironment } from 'analytics/actions'
import { cookieName, useCookie } from 'utils'

export const action = (type, payload) => ({ type, payload })

export const findFilteredUnits = ({ fuzzyStr, unitNameMap, unitsInGroup }) => {
  const loweredFuzzy = fromEmpty(fuzzyStr)
    .chain(s => (s.trim().length === 0 ? Nothing() : Just(s)))
    .map(f => f.toLowerCase())
    .getOrElse(null)

  return R.compose(
    R.filter(u => R.isNil(unitsInGroup) || unitsInGroup.includes(u)),
    R.map(([uid, _]) => uid),
    R.filter(
      ([_, name]) =>
        R.isNil(loweredFuzzy) || name.toLowerCase().includes(loweredFuzzy)
    ),
    R.toPairs
  )(unitNameMap)
}

const filterError = error => error

export const storeErrorAction = error => dispatch => {
  dispatch(action(ANS.STORE_ERROR, filterError(error)))
}

// eslint-disable-next-line no-unused-vars
const setUnitFilterData = name => data => (dispatch, getState) => {
  dispatch(action(name, data))
  // dispatch(
  //   action(
  //     ANS.STORE_FILTERED_UNITS,
  //     findFilteredUnits(sel.getUnitFilterInfo(getState()))
  //   )
  // )
}

export const setUnits = setUnitFilterData(STORE_UNITS)
export const setUnitGroups = setUnitFilterData(ANS.STORE_UNIT_GROUPS)
export const setFuzzyStr = setUnitFilterData(ANS.STORE_FUZZY_STR)
// export const setFilteredUnitGroup = setUnitFilterData(
//   ANS.STORE_FILTERED_UNIT_GROUP
// )

// eslint-disable-next-line no-unused-vars
const loadSupportDataTaskOld = (dispatch, getState) => {
  const targetInfo = getApiTargetInfo(getState())

  dispatch(action(ANS.LOADING_INIT_DATA, true))
  return List.of(
    api
      .getEnvConfig(targetInfo)()
      .map(data => dispatch(action(STORE_ENV_CONFIG, data))),
    loadDateRelatedDataTask({ dispatch, getState }),
    api
      .getCompanyNameMap(targetInfo)()
      .map(data => dispatch(action(STORE_COMPANY_NAME_MAP, data))),
    // api
    //   .getUtilityNameMap(targetInfo)()
    //   .map(data => dispatch(action(STORE_UTILITY_NAME_MAP, data))),
    // api.getCauseCodeAll(targetInfo).map(data => {
    //   dispatch(action(CAUSE_CODE, data))
    // }),
    api.getEventTypes(targetInfo).map(data => {
      dispatch(action(EVENT_TYPES, data))
    }),
    api.getStationInfo(targetInfo).map(data => {
      dispatch(action(STATIONS, data))
    }),
    // below we get it from selector
    // api.getUnitSystemCompCauseCodeMap(targetInfo).map(data => {
    //   dispatch(action(STORE_UNIT_CAUSE_CODE_MAP, data))
    // }),
    api.getCauseCodeMgmtInfo(targetInfo).map(data => {
      // dispatch(action(ANS.STORE_CAUSE_CODE_MAP, causeCodeList(data)))
      dispatch(action(ANS.STORE_CAUSE_CODE_TABLE, data))
    }),
    api.getUnitTypeInfo(targetInfo).map(data => {
      dispatch(action(STORE_UNIT_TYPE_CODE, data))
    }),
    api.getUtilityOperatorInfo(targetInfo).map(data => {
      dispatch(action(ANS.STORE_UTILITY, data))
    }),
    api.getReportNameMap(targetInfo).map(data => {
      const idNameMap = R.reduce(
        (a, b) => ({ ...a, ...b }),
        {},
        data.map(d => ({ [d.reportId]: d.reportName }))
      )
      const idCodeMap = R.reduce(
        (a, b) => ({ ...a, ...b }),
        {},
        data.map(d => ({ [d.reportId]: d.displayCode }))
      )
      dispatch(action(ANS.STORE_REPORTNAME_MAP, idNameMap))
      dispatch(action(ANS.STORE_REPORT_DISPLAYCODE_MAP, idCodeMap))
    }),
    api.getUserRoles(targetInfo).map(data => {
      dispatch(action(ANS.STORE_USER_ROLES, data))
    }),
    // api.getUserActions(targetInfo).map(data => {
    //   dispatch(action(ANS.STORE_ACTION_PEREMIT, data))
    // }),
    // api.getUserReports(targetInfo).map(data => dispatch(action(ANS.STORE_USER_REPORT, data))),
    api
      .getAmpCodeMgmtInfo(targetInfo)
      .map(data => dispatch(action(ANS.STORE_AMPLIFICATION, data))),
    api
      .getFailCodeMgmtInfo(targetInfo)
      .map(data => dispatch(action(ANS.STORE_FAILCODE, data))),
    api
      .getUserInfo(targetInfo)
      .map(data => dispatch(action(ANS.STORE_USERINFO, data))),
    api
      .getUnitNameMap(targetInfo)
      .map(data => dispatch(action(ANS.STORE_UNIT_NAME_MAP, data))),
    api
      .marginPnodeZoneEffectieve(targetInfo)
      .map(data => dispatch(action(ANS.STORE_PNODE_ZONE_EFFECTIVE, data)))
  )
    .traverse(Task.of, _ => _)
    .map(_ => {
      dispatch(action(ANS.LOADING_INIT_DATA, false))
    })
    .map(_ => loadAnalyticsEnvironment()(dispatch, getState))
}

// const causeCodeList = R.compose(
//   R.fromPairs,
//   R.map(a => [a.causeCode, a.description])
// )

export const loadEnv = (error, done) => (dispatch, getState) => {
  const targetInfo = getApiTargetInfo(getState())
  // console.log('state is', getState())
  const authUrl = getMetaConfig('authServer', targetInfo.baseUrl)
  authApi
    .getAuthConfig({ ...targetInfo, baseUrl: authUrl })()
    .chain(data => {
      dispatch(action(STORE_ENV_CONFIG, data))
      // console.log('jwt Expired', sel.isExpiredJWTData(getState()))
      if (
        !getEnvConfig(getState()).authGodMode &&
        sel.isExpiredJWTData(getState())
      ) {
        finalizeLogout(false)
        dispatch(action(ANS.STORE_JWT, null))
      } else if (
        getEnvConfig(getState()).authGodMode ||
        (isAuthenticated(getState()) && !sel.isExpiredJWTData(getState()))
      ) {
        return loadSupportDataTask(dispatch, getState)
      }
      return Task.of('done')
    })
    .fork(e => {
      errorLogger(e)
      error(e)
    }, done)
}

// const setFuelType = fuelType => action(ANS.STORE_PJM_FUEL_TYPE, fuelType)
// export const saveUtilityNameMap = utilityNameMap =>
//   action(STORE_UTILITY_NAME_MAP, utilityNameMap)

const loadSupportDataTask = (dispatch, getState) => {
  const targetInfo = getApiTargetInfo(getState())

  dispatch(action(ANS.LOADING_INIT_DATA, true))

  const mapToDispatchData = data => {
    const {
      companyNameMap = {},
      eventTypes = [],
      station = [],
      causeCode = [],
      unitTypes = [],
      utilityOperator = [],
      reportNameMapping = [],
      frontEndRoles = [],
      amplificationCode = [],
      failCodes = [],
      gadsUserInfos = {},
      unitNameMap = {},
      maPnodeZoneList = [],
      unitGroups = [],
      units = [],
      hours = [],
      contribOpCondition = [],
    } = data
    if (hours.length > 0) dispatch(action(ANS.STORE_HOURS_IN_DAY, hours))
    if (units.length > 0) setUnits(units)(dispatch, getState)
    if (unitGroups.length > 0) setUnitGroups(unitGroups)(dispatch, getState)

    if (Object.keys(companyNameMap).length > 0)
      dispatch(action(STORE_COMPANY_NAME_MAP, companyNameMap))
    if (eventTypes.length > 0) dispatch(action(EVENT_TYPES, eventTypes))
    if (station.length > 0) dispatch(action(STATIONS, station))
    if (causeCode.length > 0)
      dispatch(action(ANS.STORE_CAUSE_CODE_TABLE, causeCode))
    if (unitTypes.length > 0) dispatch(action(STORE_UNIT_TYPE_CODE, unitTypes))
    if (utilityOperator.length > 0)
      dispatch(action(ANS.STORE_UTILITY, utilityOperator))
    if (frontEndRoles.length > 0)
      dispatch(action(ANS.STORE_USER_ROLES, frontEndRoles))
    if (amplificationCode.length > 0)
      dispatch(action(ANS.STORE_AMPLIFICATION, amplificationCode))
    if (causeCode.length > 0) dispatch(action(ANS.STORE_FAILCODE, failCodes))
    if (Object.keys(gadsUserInfos).length > 0)
      dispatch(action(ANS.STORE_USERINFO, gadsUserInfos))
    if (Object.keys(unitNameMap).length > 0)
      dispatch(action(ANS.STORE_UNIT_NAME_MAP, unitNameMap))
    if (contribOpCondition.length > 0)
      dispatch(action(ANS.STORE_CARD97_CONT_OP_COND, contribOpCondition))

    if (maPnodeZoneList.length > 0) {
      // dispatch(action(ANS.STORE_PNODE_ZONE_EFFECTIVE, maPnodeZoneList))
      setPNodeZoneList(maPnodeZoneList)(dispatch, getState)
    }

    if (reportNameMapping.length > 0) {
      const idNameMap = R.reduce(
        (a, b) => ({ ...a, ...b }),
        {},
        reportNameMapping.map(d => ({ [d.reportId]: d.reportName }))
      )
      const idCodeMap = R.reduce(
        (a, b) => ({ ...a, ...b }),
        {},
        reportNameMapping.map(d => ({ [d.reportId]: d.displayCode }))
      )
      dispatch(action(ANS.STORE_REPORTNAME_MAP, idNameMap))
      dispatch(action(ANS.STORE_REPORT_DISPLAYCODE_MAP, idCodeMap))
    }
  }

  return List.of(
    api
      .getEnvConfig(targetInfo)()
      .map(data => dispatch(action(STORE_ENV_CONFIG, data))),
    // loadDateRelatedDataTask({ dispatch, getState }),
    api.getAppInitRequiredData(targetInfo).map(mapToDispatchData)
    // api.getAppInitData(targetInfo).map(mapToDispatchData)
  )
    .traverse(Task.of, _ => _)
    .map(_ => {
      dispatch(action(ANS.LOADING_INIT_DATA, false))
    })
    .map(_ =>
      api
        .getAppInitData(targetInfo)
        .fork(err => console.log(err), mapToDispatchData)
    )
    .map(_ => loadAnalyticsEnvironment()(dispatch, getState))
}

export const loadDateRelatedDataTask = props => {
  const { dispatch, getState } = props
  const date = props.date ? props.date : getTransDate(getState())
  const endDate = props.endDate ? props.endDate : sel.getEndDate(getState())
  const withRetriedUnits =
    props.withRetriedUnits === true || props.withRetriedUnits === 'Y'
      ? 'Y'
      : 'N'
  const targetInfo = getApiTargetInfo(getState())
  if (
    !getEnvConfig(getState()).authGodMode &&
    sel.isExpiredJWTData(getState())
  ) {
    // dispatch(action(ANS.STORE_JWT, null))
    return Task.of('OK')
  }

  const dispatchData = units => unitGroups => hrsInDay => {
    const isActiveUnit = u =>
      withRetriedUnits === 'Y' ||
      u.retired === 0 ||
      R.isNil(u.retiredDate) ||
      moment(u.retiredDate)
        .endOf('month')
        .isAfter(date)
    // dispatch(action(STORE_TRANS_DATE, date))

    const oldHe = sel.getHrsInDay(getState())
    if (!R.equals(oldHe, hrsInDay))
      dispatch(action(ANS.STORE_HOURS_IN_DAY, hrsInDay))

    const oldGroup = sel.getUnitGroups(getState())
    if (!R.equals(oldGroup, unitGroups))
      setUnitGroups(unitGroups)(dispatch, getState)

    const oldUnits = sel.getUnits(getState())

    const d1UnitId = oldUnits.map(d => d.unitId).sort()
    const d2UnitId = (units || []).map(d => d.unitId).sort()

    if (!R.equals(d1UnitId, d2UnitId)) {
      const filterUnits = units.filter(isActiveUnit)

      setUnits(filterUnits)(dispatch, getState)

      // dispatch(action(ANS.UTILITY_STATIONS_MAP), units)
    }
  }
  const wraperDispatch = data => {
    const { units, unitGroups, hours } = data
    dispatchData(units)(unitGroups)(hours)
  }

  return Task.of(wraperDispatch).ap(
    api.getUnitsOnDates(targetInfo)(date, endDate, withRetriedUnits)
  )

  // return Task.of(dispatchData)
  //   .ap(api.getUnits(targetInfo)(date, endDate))
  //   .ap(api.getUnitGroup(targetInfo)(endDate, false))
  //   .ap(api.getHeInDay(targetInfo)(date))
}

export const loadDataForDate = (date, endDate, withRetriedUnits = false) => (
  dispatch,
  getState
) => {
  // dispatch(action(ANS.LOADING_UNITES, true))
  // spin  confused that its from retrieve insted of just for load
  // console.log(
  //   date && date.format('MM/DD/YYYY'),
  //   endDate && endDate.format('MM/DD/YYYY')
  // )
  loadDateRelatedDataTask({
    date: date.clone().startOf('month'),
    endDate: (endDate || date).clone().endOf('month'),
    withRetriedUnits: withRetriedUnits ? 'Y' : 'N',
    dispatch,
    getState,
  }).fork(errorLogger, e => {
    // dispatch(action(ANS.LOADING_UNITES, false))
    return e
  })
  // .map(e => dispatch(action(ANS.LOADING_UNITES, false)))
}

// eslint-disable-next-line no-unused-vars
export const setEndDate = date => (dispatch, getState) => {
  dispatch({ type: ANS.STORE_END_DATE, payload: date })
}

export const setTransDate = date => (dispatch, getState) => {
  const currentDate = getTransDate(getState())

  if (date.format('YYYY-MM-DD') === currentDate.format('YYYY-MM-DD')) {
    return
  }
  loadDataForDate(date)(dispatch, getState)
}

// eslint-disable-next-line no-unused-vars
export const setPNodeZoneList = data => (dispatch, getState) => {
  dispatch(action(ANS.STORE_PNODE_ZONE_EFFECTIVE, data))
}

export const storeApiUrl = url => action(STORE_API_URL, url)

/* export const setScheduleAvailability = createContextAction(
  ({ selectedData, date, apiInfo, retrieve, available, setErr = errorLogger, daOrRt }) => {
    const prepareRequset = R.compose(
      R.uniqWith(shallowEqual),
      R.map(({ unitId, scheduleId }) => ({
        unitId,
        scheduleId,
        daOrRt: daOrRt ? daOrRt : 'auto',
        available,
        transDate: date.format('YYYY-MM-DD'),
      })),
      R.filter(s => s.scheduleId <= 9)
    )
    const selection = prepareRequset(selectedData)
    api
      .saveScheduleSelection(apiInfo)({ selection, date, daOrRt })
      .fork(setErr, retrieve)
  }
)

export const setScheduleAvailabilityUpdate = createContextAction(
  ({ selectedData, date, apiInfo, retrieve, available, setErr = errorLogger }) => {
    if (R.filter(s => s.scheduleId > 9, selectedData).length > 0) {
      setErr('Avaialability can only be set for COST scheudles')
      return
    }
    const prepareRequest = R.compose(
      R.map(({ unitId, scheduleId, he }) => ({
        unitId,
        scheduleId,
        he,
        available,
        transDate: date.format('YYYY-MM-DD'),
      })),
      R.filter(s => s.scheduleId <= 9)
    )
    const selection = prepareRequest(selectedData)
    api
      .saveScheduleSelectionUpdate(apiInfo)(selection)
      .fork(setErr, retrieve)
  }
) */

/** auth actions **/

// eslint-disable-next-line no-unused-vars
export const saveJwt = jwt => (dispatch, getState) => {
  if (window && window.localStorage && !useCookie) {
    window.localStorage.setItem(JWT_KEY, jwt)
  }

  dispatch(action(ANS.STORE_JWT, jwt))
  // const date = fromNullable(getTransDate(getState())).getOrElse(moment().startOf('d'))
  console.log('loading from jwt saving/inject')
}

export const doLogin = cred => (dispatch, getState) => {
  const targetInfo = getApiTargetInfo(getState())
  const authUrl = getMetaConfig('authServer', targetInfo.baseUrl)

  authApi
    .doLogin({ ...targetInfo, baseUrl: authUrl })(cred)
    .chain(resp => {
      if (resp?.code === '2fa_registration_required') {
        dispatch(setTwoFactorRegistration(cred))
      } else if (resp?.code === '2fa_code_required') {
        dispatch(setTwoFactorRequired(true))
        dispatch(setTwoFactorOptions(resp))
      } else {
        const jwt = resp

        console.log(
          'jwt from response avaliable',
          !!jwt,
          ' cookie name is ',
          cookieName
        )

        if (jwt != null && jwt.trim().length > 0)
          saveJwt(jwt)(dispatch, getState)
        return loadSupportDataTask(dispatch, getState)
      }
    })
    .fork(
      err => dispatch(setLoginError(err)),
      _ => _
    )
}

export const doLoginWithoutDataTask = ({ username, password }) => (
  dispatch,
  getState
) => {
  const targetInfo = getApiTargetInfo(getState())
  const authUrl = getMetaConfig('authServer', targetInfo.baseUrl)
  authApi
    .doLogin({ ...targetInfo, baseUrl: authUrl })({ username, password })
    .chain(jwt => {
      // console.log('login W data task', jwt)
      return saveJwt(jwt)(dispatch, getState)
      // return loadSupportDataTask(dispatch, getState)
    })
    .fork(
      err => dispatch(setLoginError(err)),
      _ => _
    )
}

export const setLoginError = err => action(ANS.STORE_LOGIN_ERROR, err)

export const setTwoFactorRegistration = value =>
  action(ANS.STORE_2FA_REGISTRATION, value)
export const setTwoFactorRequired = value =>
  action(ANS.STORE_2FA_REQUIRED, value)

export const setTwoFactorOptions = value => action(ANS.STORE_2FA_OPTIONS, value)

export const convertIdToken = jwt => (dispatch, getState) => {
  const targetInfo = getApiTargetInfo(getState())
  console.log('sending jwt')
  pgads
    .convertIdToken(targetInfo)(jwt)

    .chain(resp => {
      const jwt = resp
      console.log(
        'jwt from convert id response is',
        jwt,
        ' cookie name is ',
        cookieName
      )

      if (jwt != null && jwt.trim().length > 0) saveJwt(jwt)(dispatch, getState)
      return loadSupportDataTask(dispatch, getState)
    })
    .fork(
      err => dispatch(setLoginError(err)),
      _ => _
    )
}
